<template>
  <div>
    <b-row class="toolbar-ptc">
      <b-col></b-col>
      <b-col class="text-center title">行銷活動 / 行銷活動管理</b-col>
      <b-col>
        <div class="text-right">
          <b-btn class="btn btn-ptc1" v-b-toggle.collapse1>查詢</b-btn>
          <router-link
            :to="{ name: 'event_add', params: { search: search } }"
            class="btn btn-normal-ptc1"
            tag="button"
            v-if="FunctionPermission > 1"
          >新增活動</router-link>
        </div>
      </b-col>
    </b-row>

    <div id="func-content">
      <!-- 查詢區 -->
      <b-collapse id="collapse1" class="mt-2" style="margin-bottom: 10px;">
        <b-card class="bg-default-card">
          <div class="row">
            <div class="col-lg-12">
              <div class="p-4 box-shadow">
                <div class="row">
                  <label class="control-label col-md-2">活動標題：</label>
                  <div class="col-md-3">
                    <input
                      type="text"
                      class="form-control"
                      v-model="search.title"
                      placeholder="請輸入關鍵字搜尋"
                    >
                  </div>
                </div>
                <div class="row mt-3">
                  <label class="control-label col-md-2">效期區間：</label>
                  <div class="col-md-3">
                    <input
                      type="date"
                      class="form-control"
                      v-model="search.sdate"
                      max="9999-12-31"
                      @input="changeDate($event, 1)"
                      @keydown="keydownDate($event, 1)"
                    >
                  </div>
                  <label class="mt-2">至</label>
                  <div class="col-md-3">
                    <input
                      type="date"
                      class="form-control"
                      v-model="search.edate"
                      :min="search.sdate"
                      max="9999-12-31"
                      @input="changeDate($event, 2)"
                      @keydown="keydownDate($event, 2)"
                    >
                  </div>
                  <div class="col-md-3">
                    <button type="button" class="btn btn-ptc1" @click="btnQuery">查詢</button>
                    <button type="button" class="btn btn-ptc1" @click="reset">重設</button>
                  </div>
                </div>
                <div class="row mt-3">
                  <label class="control-label col-md-2">品牌：</label>
                  <div class="col-md-3">
                    <!-- 改成單選 select -->
                    <select class="form-control" v-model="search.brand_code">
                      <option value="">全部</option>
                      <option value="MWD">麥味登</option>
                      <option value="CM">炸雞大師</option>
                      <option value="REAL">REAL</option>
                      <option value="SJ">涮金鍋</option>
                    </select>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </b-card>
      </b-collapse>

      <!-- 列表區 -->
      <b-card class="bg-default-card">
        <div class="row">
          <div class="col-lg-12">
            <b-tabs card class="tab_color" v-model="search.tabIndex">
              <!-- 上架中 -->
              <b-tab title="上架中" @click="changeTab(0)">
                <div class="row">
                  <div class="col-lg-6">
                    <button
                      type="button"
                      class="btn btn-ptc1"
                      :class="{ 'btn-active': search.target_type==1 }"
                      @click="changeTable(1)"
                    >最新活動</button>
                    <button
                      type="button"
                      class="btn btn-ptc1"
                      :class="{ 'btn-active': search.target_type==2 }"
                      @click="changeTable(2)"
                    >新開幕</button>
                    <button
                      type="button"
                      class="btn btn-ptc1"
                      :class="{ 'btn-active': search.target_type==3 }"
                      @click="changeTable(3)"
                    >APP公告</button>
                  </div>
                  <div class="col-lg-6">
                    <div class="float-right" v-show="!isSetTop">
                      <button
                        type="button"
                        class="btn btn-ptc1"
                        @click="setTop"
                        v-if="FunctionPermission > 1"
                      >設定置頂</button>
                    </div>
                    <div class="float-right" v-show="isSetTop">
                      <button type="button" class="btn btn-save" @click="save">儲存</button>
                      <button type="button" class="btn btn-clear" @click="cancel">取消</button>
                    </div>
                  </div>
                  <div class="col-lg-12 mt-2">
                    <div class="table-responsive">
                      <table class="table table-bordred table-striped">
                        <thead>
                        <tr>
                          <th>圖片</th>
                          <th>品牌</th>
                          <th>開始日期</th>
                          <th>結束日期</th>
                          <th>狀態</th>
                          <th>點閱人次</th>
                          <th>異動人員</th>
                          <th>異動時間</th>
                          <th v-show="search.target_type==3">會員贈點活動</th>
                          <th>置頂</th>
                          <th></th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr v-for="x in items" :key="x.ID">
                          <td><img width="150px" :src="x.CoverImageURL"></td>
                          <td>
                            <span v-if="normalizeBrand(x.BrandCode).length">
                              {{ normalizeBrand(x.BrandCode).join(',') }}
                            </span>
                          </td>
                          <td>{{x.EnabledAt | formatDate}}</td>
                          <td>{{x.DisabledAt | formatDate}}</td>
                          <td>
                            <span v-if="x.Status==0">草稿</span>
                            <span v-else-if="x.Status==1&&x.EnabledAt.substring(0,10)>today">已排程</span>
                            <span v-else style="color:red">已上架</span>
                          </td>
                          <td>{{x.Visited}}</td>
                          <td>{{x.UpdatedName}}</td>
                          <td>{{x.WebUpdatedAt | formatFullDate}}</td>
                          <td v-show="search.target_type==3">{{x.IsMemberReward===true ? '是' : '否'}}</td>
                          <td>
                            <b-form-checkbox
                              :checked="isSetTop ? (isSeted ? top_item.ID==x.ID : x.Sticky) : x.Sticky"
                              :disabled="!isSetTop"
                              v-if="x.Status==1 && x.EnabledAt.substring(0,10)<=today"
                              @change="chkTopChange($event, x)"
                            ></b-form-checkbox>
                          </td>
                          <td>
                            <router-link
                              v-b-tooltip.hover.top
                              title="編輯"
                              class="btn-circle btn-circle-ptc1"
                              tag="button"
                              :to="{ name: 'event_edit', params: { item: x, action: 1, search: search } }"
                              v-show="!isSetTop"
                              v-if="FunctionPermission > 1"
                            ><span class="fa fa-pencil-alt"></span></router-link>
                            <button
                              v-b-tooltip.hover.top
                              title="預覽"
                              class="btn-circle btn-circle-ptc1"
                              @click="showDetail(x)"
                            ><span class="fa fa-search-plus"></span></button>
                            <router-link
                              v-b-tooltip.hover.top
                              title="複製"
                              class="btn-circle btn-circle-ptc1"
                              tag="button"
                              :to="{ name: 'event_edit', params: { item: x, action: 2, search: search } }"
                              v-show="!isSetTop"
                              v-if="FunctionPermission > 1"
                            ><span class="fa fa-copy"></span></router-link>
                          </td>
                        </tr>
                        </tbody>
                      </table>
                    </div>
                    <div class="row" style="padding: 0 1rem">
                      <b-pagination
                        size="md"
                        :total-rows="totalRows"
                        v-model="search.currentPage"
                        :per-page="pageRows"
                        @change="changePage"
                      ></b-pagination>
                      <label style="margin:8px">{{startRowNum}}到{{endRowNum}}，總共 {{totalRows}}筆</label>
                    </div>
                  </div>
                </div>
              </b-tab>

              <!-- 已下架 -->
              <b-tab title="已下架" @click="changeTab(1)">
                <div class="row">
                  <div class="col-lg-12">
                    <button
                      type="button"
                      class="btn btn-ptc1"
                      :class="{ 'btn-active': search.target_type==1 }"
                      @click="changeTable(1)"
                    >最新活動</button>
                    <button
                      type="button"
                      class="btn btn-ptc1"
                      :class="{ 'btn-active': search.target_type==2 }"
                      @click="changeTable(2)"
                    >新開幕</button>
                    <button
                      type="button"
                      class="btn btn-ptc1"
                      :class="{ 'btn-active': search.target_type==3 }"
                      @click="changeTable(3)"
                    >APP公告</button>
                  </div>
                  <div class="col-lg-12 mt-2">
                    <div class="table-responsive">
                      <table class="table table-bordred table-striped">
                        <thead>
                        <tr>
                          <th>圖片</th>
                          <th>品牌</th>
                          <th>開始日期</th>
                          <th>結束日期</th>
                          <th>點閱人次</th>
                          <th>異動人員</th>
                          <th>異動時間</th>
                          <th v-show="search.target_type==3">會員贈點活動</th>
                          <th></th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr v-for="x in items" :key="x.ID">
                          <td><img width="150px" :src="x.CoverImageURL"></td>
                          <td>
                            <span v-if="normalizeBrand(x.BrandCode).length">
                              {{ normalizeBrand(x.BrandCode).join(',') }}
                            </span>
                          </td>
                          <td>{{x.EnabledAt | formatDate}}</td>
                          <td>{{x.DisabledAt | formatDate}}</td>
                          <td>{{x.Visited}}</td>
                          <td>{{x.UpdatedName}}</td>
                          <td>{{x.WebUpdatedAt | formatFullDate}}</td>
                          <td v-show="search.target_type==3">{{x.IsMemberReward===true ? '是' : '否'}}</td>
                          <td>
                            <router-link
                              v-b-tooltip.hover.top
                              title="編輯"
                              class="btn-circle btn-circle-ptc1"
                              tag="button"
                              :to="{ name: 'event_edit', params: { item: x, action: 2, search: search } }"
                              v-if="FunctionPermission > 1"
                            ><span class="fa fa-pencil-alt"></span></router-link>
                            <button
                              v-b-tooltip.hover.top
                              title="刪除"
                              class="btn-circle btn-circle-ptc1"
                              @click="showDelete(x)"
                              v-if="FunctionPermission > 1"
                            ><span class="fas fa-trash-alt"></span></button>
                            <button
                              v-b-tooltip.hover.top
                              title="預覽"
                              class="btn-circle btn-circle-ptc1"
                              @click="showDetail(x)"
                            ><span class="fa fa-search-plus"></span></button>
                            <router-link
                              v-b-tooltip.hover.top
                              title="複製"
                              class="btn-circle btn-circle-ptc1"
                              tag="button"
                              :to="{ name: 'event_edit', params: { item: x, action: 2, search: search } }"
                              v-if="FunctionPermission > 1"
                            ><span class="fa fa-copy"></span></router-link>
                          </td>
                        </tr>
                        </tbody>
                      </table>
                    </div>
                    <div class="row" style="padding: 0 1rem">
                      <b-pagination
                        size="md"
                        :total-rows="totalRows"
                        v-model="search.currentPage"
                        :per-page="pageRows"
                        @change="changePage"
                      ></b-pagination>
                      <label style="margin:8px">{{startRowNum}}到{{endRowNum}}，總共 {{totalRows}}筆</label>
                    </div>
                  </div>
                </div>
              </b-tab>
            </b-tabs>
          </div>
        </div>
      </b-card>

      <!-- 預覽畫面Modal -->
      <b-modal ref="mdDetail" hide-footer :title="md_item.Title">
        <b-container fluid>
          <form>
            <div class="row mb-3">
              <div class="col-md-12">
                <img class="col-md-12" :src="md_imgUrl">
              </div>
              <div class="col-md-12 mt-3" style="word-break: break-all;" v-html="md_item.Content"></div>
            </div>
            <hr>
            <div class="row">
              <label class="col-lg-5" v-if="!(md_item.Status==0)">發佈人員：{{md_item.ReleaseName}}</label>
              <label class="col-lg-7" v-if="!(md_item.Status==0)">發佈時間：{{md_item.ReleaseAt | formatFullDate}}</label>
              <label class="col-lg-5">異動人員：{{md_item.UpdatedName}}</label>
              <label class="col-lg-7">異動時間：{{md_item.WebUpdatedAt | formatFullDate}}</label>
              <div class="col-lg-12">
                <div class="float-right">
                  <b-btn variant="secondary" @click="close">關閉</b-btn>
                </div>
              </div>
            </div>
          </form>
        </b-container>
      </b-modal>

      <!-- SetTop Check Modal -->
      <b-modal ref="mdCheck" hide-footer title="行銷活動置頂變更">
        <b-container fluid>
          <form>
            <div class="row mb-3">
              <label class="control-label" v-if="top_item.ID==undefined">確定取消置頂活動 ?</label>
              <label class="control-label" v-else>確定將 {{top_item.Title}} 設為置頂活動 ?</label>
            </div>
            <div class="float-right">
              <b-btn variant="primary" @click="confirm2">確定</b-btn>
              <b-btn variant="secondary" @click="cancel2">取消</b-btn>
            </div>
          </form>
        </b-container>
      </b-modal>

      <!-- Delete Check Modal -->
      <b-modal ref="mdDelete" hide-footer title="行銷活動刪除">
        <b-container fluid>
          <form>
            <div class="row mb-3">
              <label class="control-label">確定刪除活動 {{md_item.Title}} ?</label>
            </div>
            <div class="float-right">
              <b-btn variant="primary" @click="delConfirm">確定</b-btn>
              <b-btn variant="secondary" @click="delCancel">取消</b-btn>
            </div>
          </form>
        </b-container>
      </b-modal>

    </div>
  </div>
</template>

<script>
import { getFunctionPermission } from '../../../js/LoginUserFunction.js'
import { API_URL } from '../../../store/root.js'
import miniToastr from 'mini-toastr'
import axios from 'axios'
miniToastr.init()

export default {
  data () {
    return {
      search: {
        title: '',
        sdate: '',
        edate: '',
        tabIndex: 0,
        target_type: 1,
        currentPage: 1,
        brand_code: ''
      },
      today: '',
      sdateInvalid: false,
      edateInvalid: false,
      isSetTop: false,
      isSeted: false,
      totalRows: 0,
      pageRows: 20,
      startRowNum: 0,
      endRowNum: 0,
      items: [],
      top_item: {},
      md_item: {},
      md_imgUrl: undefined,
      API_URL: API_URL,
      FunctionPermission: 0
    }
  },
  created () {
    this.FunctionPermission = getFunctionPermission('F05') // 功能權限
    if (this.FunctionPermission < 1) {
      this.$router.push({ name: 'name' })
      return
    }

    const date = new Date()
    let year = date.getFullYear()
    let mon = date.getMonth() + 1
    let day = date.getDate()
    if (mon < 10) mon = '0' + mon
    if (day < 10) day = '0' + day
    this.today = year + '-' + mon + '-' + day

    this.reset()
  },
  methods: {
    // 把後端的 BrandCode 欄位統一轉成陣列
    normalizeBrand (val) {
      if (!val) return []
      const trimmed = val.trim()
      // ["MWD","CM"]
      if (trimmed.startsWith('[') && trimmed.endsWith(']')) {
        try {
          const arr = JSON.parse(trimmed)
          return Array.isArray(arr) ? arr : []
        } catch (e) {
          return []
        }
      }
      // "MWD","CM"
      if (trimmed.includes('","')) {
        return trimmed.split(',').map(s => s.replace(/"/g, '').trim()).filter(Boolean)
      }
      // 單一
      return [trimmed.replace(/"/g, '')]
    },
    changeDate (e, type) {
      if (type === 1) {
        this.sdateInvalid = e.target.validity.badInput
      } else {
        this.edateInvalid = e.target.validity.badInput
      }
    },
    keydownDate (e, type) {
      if (type === 1) {
        this.sdateInvalid = e.target.validity.badInput
      } else {
        this.edateInvalid = e.target.validity.badInput
      }
    },
    reset () {
      const date = new Date()
      const _date = new Date(date.setDate(date.getDate() - 90))
      let year = _date.getFullYear()
      let mon = _date.getMonth() + 1
      let day = _date.getDate()
      if (mon < 10) mon = '0' + mon
      if (day < 10) day = '0' + day
      this.search.sdate = year + '-' + mon + '-' + day
      this.search.edate = ''
      this.search.title = ''
      this.search.currentPage = 1
      this.sdateInvalid = false
      this.edateInvalid = false
      this.search.brand_code = ''

      this.query()
    },
    btnQuery () {
      this.search.currentPage = 1
      this.query()
    },
    query () {
      this.isSetTop = false
      let isBirth = true
      let status = 1

      if (this.search.tabIndex !== 2) {
        if (this.search.edate && this.search.sdate > this.search.edate) {
          miniToastr.error('查詢日期區間錯誤，請重新輸入')
          return
        }
        if (this.sdateInvalid || this.edateInvalid) {
          miniToastr.error('日期格式輸入錯誤，請重新輸入')
          return
        }
        isBirth = false
        status = this.search.tabIndex === 1 ? 2 : 10
      }

      const brandCodes = this.search.brand_code ? [this.search.brand_code] : []

      this.$parent.Loading = true
      return axios.post(API_URL + '/web/marketing/getpageevents/v1', {
        title: this.search.title,
        sdate: this.search.sdate,
        edate: this.search.edate,
        status: status,
        targetType: this.search.target_type,
        page: this.search.currentPage,
        pageRows: this.pageRows,
        birthdayEvent: isBirth,
        brandCodes: brandCodes
      })
        .then((response) => {
          this.$store.commit('TOKEN', response.data.jwt)
          this.$parent.Loading = false

          if (response.data.result === '0000') {
            this.totalRows = (response.data.count === undefined) ? 0 : response.data.count
            this.items = response.data.data
            this.startRowNum = (response.data.count === undefined || response.data.count === 0) ? 0 : this.pageRows * (this.search.currentPage - 1) + 1
            this.endRowNum = (response.data.count === undefined || response.data.count === 0)
              ? 0
              : (this.pageRows > response.data.count)
                ? response.data.count
                : (this.search.currentPage * this.pageRows) >= response.data.count
                  ? response.data.count
                  : this.search.currentPage * this.pageRows
          } else if (response.data.result === '0006') {
            this.$parent.logOut(true, true)
          } else {
            this.items = []
            miniToastr.error(response.data.message, '資料讀取異常')
            console.log(response.data.message)
          }
        })
        .catch((error) => {
          this.items = []
          this.$parent.Loading = false
          miniToastr.error(error, '資料讀取異常')
          console.log(error)
        })
    },
    changeTab (val) {
      this.items = []
      this.search.currentPage = 1
      this.search.tabIndex = val
      this.query()
    },
    changeTable (type) {
      this.items = []
      this.search.target_type = type
      this.search.currentPage = 1
      this.query()
    },
    changePage (page) {
      this.search.currentPage = page
      this.query()
    },
    setTop () {
      this.top_item = {}
      this.isSetTop = true
      this.isSeted = false
    },
    chkTopChange (selected, item) {
      this.isSeted = true
      if (selected) {
        this.top_item = item
      } else {
        this.top_item = {}
      }
    },
    cancel () {
      this.top_item = {}
      this.isSetTop = false
      this.isSeted = false
    },
    save () {
      if (this.isSeted === true) {
        this.$refs.mdCheck.show()
      } else {
        this.top_item = {}
        this.isSetTop = false
        this.isSeted = false
      }
    },
    cancel2 () {
      this.$refs.mdCheck.hide()
      this.top_item = {}
      this.isSetTop = false
      this.isSeted = false
    },
    confirm2 () {
      this.$refs.mdCheck.hide()

      this.$parent.Loading = true
      return axios.post(API_URL + '/web/marketing/settopevent/v1', {
        id: this.top_item.ID === undefined ? 0 : this.top_item.ID,
        targetType: this.search.target_type
      })
        .then((response) => {
          this.$store.commit('TOKEN', response.data.jwt)
          this.$parent.Loading = false

          if (response.data.result === '0000') {
            miniToastr.success('置頂活動已變更')
            this.query()

            this.top_item = {}
            this.isSetTop = false
            this.isSeted = false
          } else if (response.data.result === '0006') {
            this.$parent.logOut(true, true)
          } else {
            miniToastr.error(response.data.message, '資料變更錯誤')
            console.log(response.data.message)
          }
        })
        .catch((error) => {
          this.$parent.Loading = false
          miniToastr.error(error, '資料變更錯誤')
          console.log(error)
        })
    },
    showDetail (item) {
      this.md_item = item
      this.md_item.Content = "<style>.ql-size-small{font-size: 0.75em;}.ql-size-large{font-size: 1.5em;}.ql-size-huge {font-size: 2.5em;}.ql-align-right{text-align: right;}.ql-align-center{text-align: center;}</style>" + item.Content
      this.md_imgUrl = item.ContentImageURL
      this.$refs.mdDetail.show()
    },
    close () {
      this.$refs.mdDetail.hide()
    },
    showDelete (item) {
      this.md_item = item
      this.$refs.mdDelete.show()
    },
    delCancel () {
      this.$refs.mdDelete.hide()
    },
    delConfirm () {
      this.$refs.mdDelete.hide()

      this.$parent.Loading = true
      return axios.post(API_URL + '/web/marketing/deleteevent/v1', {
        id: this.md_item.ID
      })
        .then((response) => {
          this.$store.commit('TOKEN', response.data.jwt)
          this.$parent.Loading = false

          if (response.data.result === '0000') {
            miniToastr.success('行銷活動已刪除')
            this.query()
          } else if (response.data.result === '0006') {
            this.$parent.logOut(true, true)
          } else {
            miniToastr.error(response.data.message, '資料變更錯誤')
            console.log(response.data.message)
          }
        })
        .catch((error) => {
          this.$parent.Loading = false
          miniToastr.error(error, '資料變更錯誤')
          console.log(error)
        })
    }
  },
  filters: {
    formatDate: function (date) {
      var d = new Date(date)
      var year = d.getFullYear()
      var mon = (d.getMonth() + 1) < 10 ? '0' + (d.getMonth() + 1) : d.getMonth() + 1
      var day = d.getDate() < 10 ? '0' + d.getDate() : d.getDate()
      return year + '/' + mon + '/' + day
    },
    formatFullDate: function (date) {
      var d = new Date(date)
      var year = d.getFullYear()
      var mon = (d.getMonth() + 1) < 10 ? '0' + (d.getMonth() + 1) : d.getMonth() + 1
      var day = d.getDate() < 10 ? '0' + d.getDate() : d.getDate()
      var hour = d.getHours() < 10 ? '0' + d.getHours() : d.getHours()
      var min = d.getMinutes() < 10 ? '0' + d.getMinutes() : d.getMinutes()
      var sec = d.getSeconds() < 10 ? '0' + d.getSeconds() : d.getSeconds()
      return year + '/' + mon + '/' + day + ' ' + hour + ':' + min + ':' + sec
    }
  }
}
</script>

<style scoped>
.box-shadow {
  box-shadow: 0px 0px 1px 1px #cfcfcf
}
.btn-active {
  background-color: #124734!important;
}
/* Vue2Editor */
.ql-size-small{font-size: 0.75em;}
.ql-size-large{font-size: 1.5em;}
.ql-size-huge {font-size: 2.5em;}
.ql-align-right{text-align: right;}
.ql-align-center{text-align: center;}
</style>



// WEBPACK FOOTER //
// src/pages/marketing/event/List.vue